// src/utils/fetchCSRFToken.js
import api from '../services/api';

const fetchCSRFToken = async () => {
  try {
    await api.get('users/csrf-cookie/');
  } catch (err) {
    console.error('Failed to fetch CSRF token:', err);
  }
};

export default fetchCSRFToken;
